import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NOT_AVAILABLE, IconNames } from '../../../common/constants';
import { AutoUnsubscribe } from '../../../common/decorators';

@Component({
  selector: 'ui-info-field-expandable-value-list',
  templateUrl: './info-field-expandable-value-list.component.html',
  styleUrls: ['./info-field-expandable-value-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class InfoFieldExpandableValueListComponent {
  @Input() label: string | null = null;
  @Input() items: string[] = [];

  readonly notAvailable = NOT_AVAILABLE;
  readonly iconNames = IconNames;

  isOpened$ = new BehaviorSubject<boolean | null>(null);
  fits$ = new BehaviorSubject<boolean | null>(null);

  toggleHeight(): void {
    if (this.fits$.getValue()) {
      return;
    }

    if (this.isOpened$.getValue() === null) {
      this.isOpened$.next(true);

      return;
    }

    this.isOpened$.next(!this.isOpened$.getValue());
  }

  onFitEvent(event: boolean): void {
    this.fits$.next(event);
  }
}
